/** Matomo Cloud config from Varlock `VITE_MATOMO_*` (+ hostname fallback like reader). */

export type MatomoConfig = {
  enabled: boolean;
  host: string;
  siteId: number;
  trackerUrl: string;
  scriptUrl: string;
};

const PROD_ASSIST_HOST = "sidoniassist.cncc.fr";
/** Same convention as reader: prod host → 8, everything else → 5. */
const SITE_ID_PROD = 8;
const SITE_ID_NON_PROD = 5;
const DEFAULT_CLOUD_HOST = "https://cncc.matomo.cloud";
const DEFAULT_SCRIPT_URL =
  "https://cdn.matomo.cloud/cncc.matomo.cloud/matomo.js";

function parseSiteId(): number {
  const raw = import.meta.env.VITE_MATOMO_SITE_ID;
  if (raw !== undefined && raw !== "") {
    const n = Number(raw);
    if (Number.isFinite(n) && n > 0) {
      return n;
    }
  }
  if (
    typeof window !== "undefined" &&
    window.location.hostname === PROD_ASSIST_HOST
  ) {
    return SITE_ID_PROD;
  }
  return SITE_ID_NON_PROD;
}

export function getMatomoConfig(): MatomoConfig {
  const enabled = import.meta.env.VITE_MATOMO_ENABLED === "true";
  const host = (
    import.meta.env.VITE_MATOMO_HOST?.trim() || DEFAULT_CLOUD_HOST
  ).replace(/\/$/, "");
  const siteId = parseSiteId();
  const scriptUrl =
    import.meta.env.VITE_MATOMO_SCRIPT_URL?.trim() || DEFAULT_SCRIPT_URL;
  const trackerUrl =
    import.meta.env.VITE_MATOMO_TRACKER_URL?.trim() || `${host}/matomo.php`;

  return {
    enabled,
    host,
    siteId,
    trackerUrl,
    scriptUrl,
  };
}
